import React, { useState, useEffect } from 'react';
import {
  Button,
  Input,
  FormGroup,
  Label,
  FormFeedback,
  Form,
} from 'reactstrap';
import { alertError, alertSuccess } from '../../../helpers/errorHandling';
import InnerLoader from '../../../Components/Common/InnerLoader';
import { useFormik, FormikProvider } from 'formik';
import * as Yup from 'yup';
import QueryBuilderApp from '../../Promotion/QueryBuilderApp';
import { useSelector, useDispatch } from 'react-redux';
import { createOrUpdateAnalyticsPage } from '../../../actions/analytics/index';

const CreateAnalyticsPageForm = ({
  submitHandler = () => {},
  closeHandler = () => {},
  reportConfigForEdit = null,
}) => {
  const { fields } = useSelector((state) => state.promotions || {});
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const validationSchema = Yup?.object()?.shape({
    _id: Yup.string().optional(),
    name: Yup?.string()?.required('Name is required'),
  });

  const initialValues = {
    name: '',
    filterRule: {
      combinator: 'and',
      rules: [],
    },
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const res = await createOrUpdateAnalyticsPage(
          {
            ...values,
          },
          dispatch
        );

        console.log(res, 'res-30330');
        if (res?._id) {
          alertSuccess('Updated Successfully');
          submitHandler();
        } else {
          alertError({ message: 'Failed,Please try again later' });
        }
        setTimeout(() => {
          setIsLoading(false);
        }, 300);
      } catch (error) {
        setIsLoading(false);
        alertError({ message: 'Failed!,  Please try again later' });
        console.log(error);
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
    setValues,
    values,
    isSubmitting,
    setFieldValue,
  } = formik;

  return (
    <>
      <FormikProvider value={formik}>
        <Form
          onSubmit={formik.handleSubmit}
          className="d-flex flex-row gap-3 flex-wrap"
        >
          <FormGroup className="col-5">
            <Label for="configName">Name</Label>
            <Input
              id="name"
              name="name"
              placeholder="Name"
              type="text"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values?.name}
              invalid={!!errors?.name && touched?.name}
            />
            <FormFeedback>{touched?.name && errors?.name}</FormFeedback>
          </FormGroup>

          <FormGroup className="col-10">
            <Label for="rules">Filter Rule</Label>
            <QueryBuilderApp
              fieldGroups={['item']}
              data={{ ...values.filterRule }}
              updateQuery={(rule) => {
                setFieldValue('filterRule', rule);
              }}
            />
          </FormGroup>

          <div className="d-flex flex-row justify-content-end mt-3 w-100">
            <Button
              color="dark"
              size="sm"
              onClick={() => {
                closeHandler();
              }}
            >
              Close
            </Button>
            <Button color="primary" size="sm" type="submit" className="ms-2">
              {reportConfigForEdit ? 'Update' : 'Create'}
            </Button>
          </div>
        </Form>
      </FormikProvider>
      {isLoading ? <InnerLoader /> : null}
    </>
  );
};

export default CreateAnalyticsPageForm;
